module.exports = __webpack_public_path__ + "static/img/2019-10-12 14.17.40.c39c893.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/main/2019-10-12 14.17.40.jpg
// module id = 7wUP
// module chunks = 4